import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IChildActivityBankDto } from '@core/interfaces/iactivity-bank';
import { IActivity } from '@core/interfaces/iactivity-bank-report';
import { IDomainMeasureStudent } from '@core/interfaces/iclass-planning';
import { ActivityBankService } from '@core/services/activity-bank.service';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';

@Component({
  selector: 'drdp-activity-assignment-modal',
  standalone: false,
  templateUrl: './activity-assignment-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './activity-assignment-modal.component.scss'
})
export class ActivityAssignmentModalComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ActivityAssignmentModalComponent>);
  private activityBankService = inject(ActivityBankService);
  private translocoService = inject(TranslocoService);
  selectedActivityIds: number[] = [];

  onSave(): void {
    const payload: IChildActivityBankDto[] = this.data.enrollmentIds.map((enrollmentId: number) => ({
      enrollmentId,
      activityBankIds: this.selectedActivityIds,
      masterMeasureId: this.data.masterMeasureId
    }));
    
    this.activityBankService.updateChildActivitySelections(payload, this.translocoService.translate('reports.activities.savedToast'))
      .pipe(take(1)).subscribe((success: boolean) => {
        if (success) this.dialogRef.close(success);
      });
  }

  onActivitySelection(activity: IActivity): void {
    if (this.selectedActivityIds.includes(activity.activityBankId)) {
      this.selectedActivityIds = this.selectedActivityIds.filter(id => id !== activity.activityBankId);
      return;
    }

    this.selectedActivityIds.push(activity.activityBankId);
  }
}
